import { css } from "emotion";
import { Component } from "preact";
import React from "react";
import CMSComponent from "../../../components/CMSComponent";
import H2 from "../../../components/global/H2";
import H4 from "../../../components/global/H4";
import P from "../../../components/global/P";
import Image from "../../../components/Image";
import ContentBlock from "../../../components/layout/ContentBlock";
import Layout from "../../../components/layout/Layout";
import config from "../../../config";
import { updateTitle } from "../../../utils/BrowserUtils";
import FAQS from "../FAQS";
import OrganiserForm from "../forms/OrganiserForm";

const emailIcon = require("../../../assets/ic_email_form.svg");

const wrapper = css({
  textAlign: "center",
  maxWidth: 700,
  margin: "0 auto",
  h2: {
    marginBottom: 16
  },
  p: {
    marginBottom: 40
  }
});

const heading = css({
  display: "flex",
  alignItems: "center",
  marginBottom: 24,
  textAlign: "left",
  img: {
    marginRight: 12
  }
});

const faqs = [
  {
    link:
      "https://humanitix.helpdocs.io/article/qwsy003z2y-when-will-my-event-be-paid-out",
    text: "When will my event be paid out?"
  },
  {
    link:
      "https://humanitix.helpdocs.io/article/hb9m54godv-additional-questions",
    text: "How do I collect information from my attendees?"
  },
  {
    link: "https://humanitix.helpdocs.io/article/cfwbmsz6pv-email-attendees",
    text: "Can I email my attendees?"
  },
  {
    link:
      "https://humanitix.helpdocs.io/article/6zl32idesg-where-do-i-set-up-the-not-for-profit-rate",
    text: "Where do I set up the not-for-profit rate?"
  },
  {
    link:
      "https://humanitix.helpdocs.io/article/f5f9jllus5-how-can-i-change-my-account-email-or-password",
    text: "How can I change my account email or password?"
  },
  {
    link:
      "https://humanitix.helpdocs.io/article/cbidg7ln9j-can-i-transfer-my-account-to-another-one",
    text: "Can I transfer my account to another one?"
  }
];

const splitWrapper = css({
  display: "flex",
  justifyContent: "center"
});

class OrganiserSupport extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    updateTitle("Organiser Support");
  }

  render() {
    const { locale, localeData } = this.props;
    return (
      <Layout>
        <ContentBlock color="grey">
          <div className={wrapper}>
            <H2>Organiser Support</H2>
            <P>
              Check some of our FAQs, if that doesn't work for you, send an
              enquiry to our human 🙂{" "}
            </P>
            <FAQS faqs={faqs} />
            <div className={heading}>
              <Image imageURL={emailIcon} alt="" />
              <H4>Send us a message</H4>
            </div>
            <OrganiserForm locale={locale} />
          </div>
        </ContentBlock>
        {/* <div className={styles.background} />
        <div className={styles.wrapper}>
          <PageContent>
            <PageHeading
              heading="Let’s do great things together!"
              subHeading="Contact our organiser support and get all the information you need"
            />
            <Cols>
              <Left>
                <div className={styles.left}>
                  <div className={styles.textDiv}>
                    <p style={{ marginBottom: "14px", fontSize: 18 }}>
                      Planning a large and complex event? Organising your first
                      event and need that little bit of extra support?
                    </p>
                    <p
                      className={styles.desktop}
                      style={{ fontWeight: 600, fontSize: 18 }}
                    >
                      Complete the form to the right and our support team will
                      be in touch shortly!
                    </p>
                    <p
                      className={styles.mobile}
                      style={{ fontWeight: 600, fontSize: 18 }}
                    >
                      Complete the form below and our support team will be in
                      touch shortly!
                    </p>

                    <div className={styles.mobile}>
                      <OrganiserForm />
                    </div>
                    <div className={styles.breaker} />

                    <IconBlock icon={faqIcon}>
                      <h4 className={styles.iconBlockHeading}>
                        Check FAQs page for more information.
                      </h4>
                      <MoreButton path={helpUrl} label="See FAQs" locale />
                    </IconBlock>
                  </div>
                </div>
              </Left>
              <Right>
                <div className={styles.right}>
                  <div className={styles.desktop}>
                    <OrganiserForm locale={locale} />
                  </div>
                </div>
              </Right>
            </Cols>
          </PageContent>
        </div> */}
      </Layout>
    );
  }
}

export default CMSComponent(null, OrganiserSupport);
